import { isValidPhoneNumber as isValidPhoneNum } from "libphonenumber-js";

export function isValidName(value) {
  if (value === "draft campaign") return false;
  if (!value || value.trim() === "") return false;
  return value?.length > 2 && value?.length < 30;
}

export function isValidEmail(email) {
  const reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (reg.test(String(email).toLowerCase())) {
    return true;
  } else {
    return false;
  }
}
export function descriptionIsValid(str) {
  const biggestWord = "pneumonoultramicroscopicsilicovolcanoconiosis";
  let isValidDescription = true;
  if (!(str === "" || str === undefined)) {
    str.split(/\s+/).forEach((word) => {
      if (word.length > biggestWord.length) {
        isValidDescription = false;
      }
    });
  }

  return isValidDescription;
}
export function isValidPhoneNumber(num) {
  if (!num) return false;
  const number = num
    ?.replace(/\s/g, "")
    .replace(/[()]/g, "")
    .replace(/[-]/g, "");
  let phoneReg;

  if (number.startsWith("+971") || number.startsWith("971")) {
    phoneReg = new RegExp(
      /^(?:\+971|00971|971|0)(?:2|3|4|6|7|9|50|51|52|54|55|56|58)[0-9]{7}$/
    );
    return phoneReg.test(number);
  }
  // Special-case Saudi
  if (number.startsWith("+966") || number.startsWith("966")) {
    phoneReg = new RegExp(/^(9665|\+9665)(5|0|3|6|4|9|1|8|7)([0-9]{7})$/);
    return phoneReg.test(number);
  }

  return isValidPhoneNum(number);
}

export function isValidPrice(n) {
  const stringNumber = n + "";
  const integerRegExp = new RegExp(/^\d+\.?\d{0,2}$/);
  if (
    n === 0 ||
    n === "0" ||
    n === "" ||
    (integerRegExp.test(stringNumber) && stringNumber.length <= 8)
  ) {
    return true;
  } else {
    return false;
  }
}

export function isValidPartySize(value) {
  return value && value > 0;
}

export function isValidPostalCode(postalCode) {
  const postalCodePattern = /^[0-9]{5}$/; // Example: 5-digit postal code

  if (postalCodePattern.test(postalCode)) {
    return true;
  } else {
    return false;
  }
}

export function isValidCity(value) {
  return value && value.length > 3;
}

export function isValidStripeId(accountId) {
  const stripeAccountIdRegex = /^acct_[a-zA-Z0-9]{16}$/;
  return stripeAccountIdRegex.test(accountId);
}
